import { Route } from "@angular/router";
import { FazerTransferenciaPage } from "./fazer-transferencia.page";

export const FazerTransferenciaRouter: Route[] = [
  { path: 'fazer-transferencia', component: FazerTransferenciaPage }
];
